<template>
  <div class="login-page">
    <div class="login-header">
      Radish
    </div>
    <div class="login-card">
      <div
        class="error"
        v-for="(error, index) in errors"
        :key="index"
      >{{error}}</div>
      <form @submit.prevent="submitLogin">
        <label for="username">Gebruikersnaam</label>
        <input
          type="text"
          @enter="submitLogin"
          v-model="username"
          id="username"
          class="form-control"
        />
        <label for="password">Wachtwoord</label>
        <input
          type="password"
          @enter="submitLogin"
          v-model="password"
          id="password"
          class="form-control"
        />
        <button
          class="form-submit"
          @click.prevent="submitLogin"
        >Inloggen</button>
      </form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "home",
  data () {
    return {
      username: "",
      password: "",
      error: null,
      errors: []
    };
  },
  methods: {
    submitLogin () {
      if (this.username && this.password) this.dispatchLogin();

      this.errors = [];

      if (!this.username) this.errors.push("Gebruikersnaam mag niet leeg zijn");
      if (!this.password) this.errors.push("Wachtwoord mag niet leeg zijn");
    },
    dispatchLogin () {
      this.$store
        .dispatch("login", { username: this.username, password: this.password })
        .then(({ data }) => {
          localStorage.setItem("accessToken", JSON.stringify(data));
          this.$store.commit('setAccessToken', data.accessToken)
          this.$router.push("/");
        })
        .catch(error => {
          if (error === 404) this.errors.push('Gebruikersnaam niet gevonden')
          if (error === 401) this.errors.push('Combinatie gebruikersnaam/wachtwoord niet gevonden')
        });
    }
  },
  computed: {
    hasErrors () {
      return Object.keys(this.errors).find(key => {
        return !!this.errors[key];
      });
    }
  }
};
</script>
